module.exports = __webpack_public_path__ + "static/media/171ME246.8dcafd9c.jpg";